"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var meta_schema_1 = __importDefault(require("@open-rpc/meta-schema"));
var specification_extension_spec_1 = require("@open-rpc/specification-extension-spec");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getExtendedMetaSchema() {
    // NOTE: this is to make sure we don't mutate the original meta schema
    var metaSchemaCopy = JSON.parse(JSON.stringify(meta_schema_1.default));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var extensionMetaSchemaCopy = __assign({}, specification_extension_spec_1.metaSchema);
    // Process the extension and meta schema to remove the $id and $schema properties
    delete extensionMetaSchemaCopy.$schema;
    delete extensionMetaSchemaCopy.$id;
    delete metaSchemaCopy.definitions.JSONSchema.$id;
    delete metaSchemaCopy.definitions.JSONSchema.$schema;
    delete metaSchemaCopy.$schema;
    delete metaSchemaCopy.$id;
    metaSchemaCopy.properties["x-extensions"] = {
        $ref: "#/definitions/x-extensions",
    };
    metaSchemaCopy.definitions["x-extensions"] = {
        type: "array",
        items: extensionMetaSchemaCopy,
    };
    //extensionMetaSchemaCopy.properties["x-extensions"];
    return metaSchemaCopy;
}
exports.default = getExtendedMetaSchema;
